export const CALENDAR_TAB_ORDER = [
  'CALENDAR',
  'SCAN_BOOKINGS',
  'TREATMENT_PROCEDURES',
  'WALK_IN',
  'NEEDS_RESCHEDULING',
  'PATIENTS',
  'CANCELLED_BOOKING',
];

export const TABS = CALENDAR_TAB_ORDER.reduce((tabs, key, index) => {
  tabs[key] = index;
  return tabs;
}, {});
